import React from "react";

const Footer = () => {
  return (
    <footer
      className=" text-white p-4 mt-auto"
      style={{ backgroundColor: "#EB3678" }}
    >
      <p className="text-center">
        © {new Date().getFullYear()} <a href="https://ceynexlk.com/">CeynexLK</a> Digital Solutions.
        All Rights Reserved.
      </p>
    </footer>
  );
};

export default Footer;
